import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { updateWappStatus } from '@/store/wapp/actions'
import { Grid } from '@mui/material'

import CardWappConnection from '../CardWappConnection'
import ResponsibleUse from '../responsibleUse'

import s from './styles.module.scss'

const TabConnection = ({ handleTabChange }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { status: statusWapp } = useSelector((state) => state.wapp)
  const { centreProfile } = useSelector((state) => state?.centres)
  const { usersProfileConnected } = useSelector((state) => state.users)

  const { entityInLocalStorage } = usersProfileConnected
  const deviceId = entityInLocalStorage?._id

  const setInit = async () => {
    await dispatch(updateWappStatus(deviceId))
  }

  useEffect(() => {
    if (!centreProfile?.centreConfiguration?.hasWappModule) {
      navigate('/')
      return
    }

    if (!deviceId) return

    if (statusWapp === null) {
      setInit()
    }

    const interval = setInterval(() => {
      dispatch(updateWappStatus(deviceId))
    }, 5000)

    return () => {
      clearInterval(interval)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceId])

  return (
    <Grid container spacing={3} className={s.container} alignItems="flex-start">
      <Grid item xs={12} md={6}>
        <div className={s.connectionColumn}>
          <CardWappConnection handleTabChange={handleTabChange} />
        </div>
      </Grid>

      <Grid item xs={12} md={6}>
        <div className={s.infoColumn}>
          <ResponsibleUse />
        </div>
      </Grid>
    </Grid>
  )
}

export default TabConnection
